import React from 'react'

import PropTypes from 'prop-types'
import { GithubIcon, FacebookIcon, LinkedinIcon } from "../assets/svg";
import '../styles/footer.css'

const Footer = (props) => {
  return (
    <footer className={`footer-footer ${props.rootClassName} `}>
      <span className="footer-text">{props.text}</span>
      <span className="footer-text1">{props.text1}</span>
      <div className="footer-icon-group">
        <a  className="icon" href="https://github.com/rigeljohn" target="_blank" rel="noreferrer">
          <i >
            <GithubIcon />
          </i>
        </a>
        <a  className="icon" href="https://www.facebook.com/rigeljohn.jamon.7/" target="_blank" rel="noreferrer">
          <i >
            <FacebookIcon />
          </i>
        </a>
        <a   className="icon" href="https://www.linkedin.com/in/rigeljohnjamon" target="_blank" rel="noreferrer">
          <i >
            <LinkedinIcon />
          </i>
        </a>
      </div>
    </footer>
  )
}

Footer.defaultProps = {
  rootClassName: '',
  text1: '© 2024 All Rights Reserved.',
  text: 'Rigel John Jamon',
}

Footer.propTypes = {
  rootClassName: PropTypes.string,
  text1: PropTypes.string,
  text: PropTypes.string,
}

export default Footer
